import React from "react";
import { Layouts } from "../../constants/Constants";
import { Urls } from "../../constants/UrlConstants";
import holTwitterIcon from "../../assets/img/hol/social-media/twitter-icon-hol.png";
import holFacebookIcon from "../../assets/img/hol/social-media/facebook-icon.png";
import holLinkedInIcon from "../../assets/img/hol/social-media/linkedin-icon.png";
import holSocialMediaStyles from "../../assets/css/modules/shared/social-media.css";
import molTwitterIcon from "../../assets/img/hol/social-media/twitter-icon.png";
import { connect } from "react-redux";

export const SocialMedia = (props) => {
  let UrlTwitter = Urls.AxaHealthTwitter;
  let UrlFacebook = Urls.AxaHealthFacebook;
  let UrlLinkedin = Urls.AxaHealthLinkedin;
  let UrlYoutube = Urls.AxaHealthYoutube;
  let UrlInstragram = Urls.AxaHealthInstagram;

  if (props.isHol) {
    UrlTwitter = Urls.HolTwitter;
    UrlFacebook = Urls.HolFacebook;
    UrlLinkedin = Urls.HolLinkedin;
  }
  return (
    <ul className="footer-social">
      <li className="footer-social-item">
        <a
          href={UrlFacebook}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-social-link"
          aria-label="Facebook"
        >
          {props.isHol ? (
            <img
              id="holFacebookIcon"
              className={holSocialMediaStyles.holSocialMediaIcons}
              src={holFacebookIcon}
              alt=""
              aria-hidden="true"
            />
          ) : (
            <i className="icon-facebook" />
          )}
        </a>
      </li>
      {!props.isHol && (
        <React.Fragment>
          <li className="footer-social-item">
            <a
              href={UrlInstragram}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="Instagram"
            >
              <i className="icon-instagram" />
            </a>
          </li>
        </React.Fragment>
      )}
      <li className="footer-social-item">
        <a
          href={UrlLinkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-social-link"
          aria-label="LinkedIn"
        >
          {props.isHol ? (
            <img
              id="holLinkedInIcon"
              className={holSocialMediaStyles.holSocialMediaIcons}
              src={holLinkedInIcon}
              alt=""
              aria-hidden="true"
            />
          ) : (
            <i className="icon-linkedin" />
          )}
        </a>
      </li>
      {!props.isHol && (
        <React.Fragment>
          <li className="footer-social-item">
            <a
              href={UrlYoutube}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="Youtube"
            >
              <i className="icon-youtube" />
            </a>
          </li>
        </React.Fragment>
      )}
      <li className="footer-social-item">
        <a
          href={UrlTwitter}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-social-link"
          aria-label="Twitter"
        >
          {props.isHol ? (
            <img
              id="holTwitterIcon"
              className={holSocialMediaStyles.holSocialMediaIconsTwitter}
              src={holTwitterIcon}
              alt=""
              aria-hidden="true"
            />
          ) : (
            // <i className="icon-twitter" />
            <img
              id="molTwitterIcon"
              className={holSocialMediaStyles.molSocialMediaIconsTwitter}
              src={molTwitterIcon}
              alt=""
              aria-hidden="true"
            />
          )}
        </a>
      </li>
    </ul>
  );
};

export const mapSocialMediaStateToProps = (state) => ({
  isHol: state.layoutReducer && state.layoutReducer.layout === Layouts.HOL
});

export default connect(mapSocialMediaStateToProps)(SocialMedia);
